import { CompletedController } from './completed.controller';
import template from './completed.html';

export const completedComponent = {
  name: 'completedComponent',
  restrict: 'E',
  template,
  controller: CompletedController,
  controllerAs: 'vm',
  bindings: {
    aidRequest: '<'
  }
};
